import React from 'react';
import {map} from 'lodash';
import NavbarMenu, {NavbarMenuProps} from './NavbarMenu/NavbarMenu';
import NavbarButton, {NavbarButtonProps} from './NavbarButton';
import {useLocation} from 'react-router-dom';
import {isActivePath} from './is-active-path';

export interface NavbarMenuListProps {
  menus: (NavbarMenuProps | NavbarButtonProps)[];
  routed: boolean | undefined;
  // eslint-disable-next-line react/no-unused-prop-types
  experienceEverywhere?: boolean;
}

const NavbarMenuList = (props: NavbarMenuListProps) => {
  const location = useLocation();
  const {menus, routed} = props;

  return (
    <>
      {map(menus, (menu) => {
        // creates a new var
        const pathsToCheck = 'menuItems' in menu ? map(menu.menuItems, 'path') : [menu.path];
        const isActiveLink = isActivePath(pathsToCheck, location);

        return 'menuItems' in menu ? (
          <NavbarMenu
            routed={routed}
            title={menu.title}
            key={menu.title}
            menuItems={menu.menuItems}
            isActiveLink={isActiveLink}
          />
        ) : (
          <NavbarButton
            path={menu.path}
            title={menu.title}
            key={menu.title}
            routed={menu.routed}
            newTab={menu.newTab}
            isActiveLink={isActiveLink}
          />
        );
      })}
    </>
  );
};

export default NavbarMenuList;
